var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.45284 1.4569L14.0884 14.8288L0.554249 28.3239C0.333383 28.0352 0.161551 27.7121 0.0456457 27.3676C-0.0152152 26.9773 -0.0152152 26.5799 0.0456457 26.1897V3.22453C0.00508229 2.60828 0.147054 1.99203 0.45128 1.4569M19.9623 8.99702L15.5112 13.406L2.03793 0.155755C2.47477 0.00442196 2.94281 -0.0377013 3.39993 0.0340647C4.11759 0.230641 4.80249 0.533307 5.43122 0.92802L17.6252 7.67559C18.4178 8.10151 19.19 8.54926 19.9623 8.99702ZM15.5128 16.2719L19.942 20.6216L16.7313 22.4095L6.93519 27.8543C6.12392 28.3021 5.30953 28.7296 4.51698 29.2179C4.17793 29.4292 3.79766 29.5657 3.4016 29.6181C3.00554 29.6706 2.60285 29.6379 2.22047 29.5221L15.5128 16.2719ZM26.9954 14.8288C27.0076 15.3745 26.8701 15.9131 26.5978 16.3862C26.3255 16.8593 25.9289 17.2487 25.4508 17.5122L21.7908 19.5435L16.9746 14.8288L21.811 10.0329C23.0514 10.7241 24.2714 11.4152 25.4898 12.0658C25.976 12.3371 26.3754 12.7407 26.6416 13.2297C26.9078 13.7187 27.0314 14.2732 26.9954 14.8288Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/AppleIcon.d4b697315990f2ba98f2954e0a13a1ef.svg";
export { ForwardRef as ReactComponent };